module.exports = __webpack_public_path__ + "img/PersonalCenterblue.b711d715.png";